import React from "react";
import Header from "./Components/Header/Header";
import TopSection from "./Components/Main/TopSection/TopSection";
import MiddleSection from "./Components/Main/MiddleSection/MiddleSection";
import DownSection from "./Components/Main/DownSection/DownSection";
import Footer from "./Components/Footer/Footer";

const Page1 = () => {
  return (
    <>
      <Header />
      <TopSection />
      <MiddleSection />
      <DownSection />
      <Footer />
    </>
  );
};

export default Page1;
